function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.4943 0C13.6527 0 0 13.6527 0 30.4943C0 47.3473 13.6527 61.0057 30.4943 61.0057C47.3473 61.0057 61.0057 47.353 61.0057 30.4943C61 13.6527 47.3473 0 30.4943 0ZM13.5327 18.3217C15.9101 18.3217 17.836 20.2476 17.836 22.625C17.836 25.0023 15.9101 26.9454 13.5327 26.9454C11.1553 26.9454 9.22944 25.0023 9.22944 22.625C9.22944 20.2476 11.1553 18.3217 13.5327 18.3217ZM10.4581 45.6214C10.4581 34.5518 19.4475 25.5681 30.5114 25.5681C41.581 25.5681 50.5476 34.5575 50.5476 45.6214C36.8492 39.1351 23.4765 39.0094 10.4581 45.6214ZM46.2272 26.9454C43.867 26.9454 41.9239 25.0023 41.9239 22.625C41.9239 20.2476 43.867 18.3217 46.2272 18.3217C48.6046 18.3217 50.5476 20.2476 50.5476 22.625C50.5476 25.0023 48.6046 26.9454 46.2272 26.9454Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.5 35.1976C26.7282 35.1976 23.3851 37.0035 21.2706 39.7866C27.4197 38.015 33.6717 38.2321 40.0323 40.2095C37.9464 37.1863 34.4604 35.1976 30.5 35.1976Z",
  fill: "white"
});

var SvgEmoji1 = function SvgEmoji1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmoji1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emoji_1.99d9c705.svg";
export { ForwardRef as ReactComponent };